import { Icon } from './Icon';
import { Primary } from './Primary';
import { Greenfield } from './Greenfield';
import { Hackathon } from './Hackathon';
export const Logo = { Icon, Primary, Greenfield, Hackathon };
